import React from 'react'
import ListLayout from '../../../components/layout/main/ListLayout'
import { PageCard } from '../../../styles/CommonStyles'
import SwapSettings from '../../../components/main/setting/swap/SwapSettings'
import { useGetSwapSettings } from '../../../core/services/react-query/setting/swap'
import SwapSettingsList from '../../../components/main/setting/swap/SwapSettingsList'
import { ScaleLoader } from 'react-spinners'

const Swap = () => {

    const { data: swapSettings, isLoading } = useGetSwapSettings()

    return (
        <ListLayout>
            <PageCard>
                {
                    isLoading ?
                        <div className='col-span-1 sm:col-span-2 lg:col-span-4 w-full flex justify-center'>
                            <ScaleLoader
                                color={'#ffc800'}
                                height={18}
                                width={4}
                            />
                        </div> :
                        <>

                            <SwapSettings swapSettings={swapSettings} />
                            <SwapSettingsList swapSettings={swapSettings} />
                        </>
                }
            </PageCard>
        </ListLayout>
    )
}

export default Swap